




































import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Layout',
})
export default class extends Vue {
  private gotoHomePage() {
    this.$router.push({ path: '/home' });
  }

  private gotoLocationPage() {
    this.$router.push({ path: '/locationSetting' });
  }

  private logoutHandle() {
    this.$store.dispatch('user/logout');
    this.$router.push({ name: 'Login' });
  }
}
